import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalChooseFederationComponent } from '../../modal-choose-federation/modal-choose-federation.component';
import { ModalAddHorseComponent } from '../modal-add-horse/modal-add-horse.component';
import { Horse } from '../../../models/horse';
import { Usef_horse } from '../../../models/usef/usef_horse';
import { Ec_horse } from '../../../models/ec/ec_horse';


@Injectable({
  providedIn: 'root'
})
export class AddHorseViewService {

  constructor(private modal: NgbModal) { }


  doAddHorse(federation_code?: string, country_iso_3?: string): Promise<Horse> {

    return new Promise((resolve, reject) => {

      const modal_ref = this.modal.open(ModalChooseFederationComponent, { size: 'lg' });
      modal_ref.componentInstance.entity_type = 'Horse';
      modal_ref.componentInstance.event_federation_code = federation_code;
      modal_ref.componentInstance.country_iso_3 = country_iso_3;

      modal_ref.componentInstance.usef_horse_selected$.subscribe((usef_horse: Usef_horse) => {
        modal_ref.close();

        const horse: Horse = new Horse({
          id: null,
          name: usef_horse.name,
          breed: usef_horse.breed,
          color: usef_horse.color,
          sex: usef_horse.gender,
          pony: false,
          height: usef_horse.height,
          date_of_birth: usef_horse.foal_date,
          birth_place: usef_horse.country_of_origin,
          sire: usef_horse.sire,
          dam: usef_horse.dam,
          dam_sire: usef_horse.dams_sire,
          usef_number: usef_horse.id,
          ec_number: null,
          fei_id: usef_horse.fei_reg_number,
          passport_country: null,
          hidden: false
        });

        this.openAddHorseModal(horse, resolve, reject);
      }, error => {
        reject(error);
      });

      modal_ref.componentInstance.ec_horse_selected$.subscribe((ec_horse: Ec_horse) => {
        modal_ref.close();

        const horse: Horse = new Horse({
          id: null,
          name: ec_horse.HorseName,
          breed: ec_horse.Breed_Code,
          color: ec_horse.Colour_Code,
          sex: ec_horse.Sex,
          pony: false,
          height: '',
          date_of_birth: ec_horse.Birthdate,
          birth_place: '',
          sire: '',
          dam: '',
          dam_sire: '',
          usef_number: '',
          ec_number: ec_horse.EC_LifeTimeNumber,
          fei_id: '',
          passport_country: null,
          hidden: false
        });

        this.openAddHorseModal(horse, resolve, reject);
      }, error => {
        reject(error);
      });

      modal_ref.componentInstance.skipped$.subscribe(() => {
        modal_ref.close();

        const horse: Horse = new Horse({
          id: null,
          name: '',
          breed: '',
          color: '',
          sex: '',
          pony: false,
          height: '',
          date_of_birth: '',
          birth_place: '',
          sire: '',
          dam: '',
          dam_sire: '',
          usef_number: '',
          ec_number: null,
          fei_id: '',
          passport_country: null,
          hidden: false
        });

        this.openAddHorseModal(horse, resolve, reject);
      }, error => {
        reject(error);
      });

    });

  }


  private openAddHorseModal(horse: Horse, resolve: (h: Horse) => void, reject: (e: any) => void): void {
    const modal_add = this.modal.open(ModalAddHorseComponent, { size: 'lg' });
    modal_add.componentInstance.horse = horse;

    modal_add.componentInstance.horse_saved$.subscribe((saved_horse: Horse) => {
      modal_add.close();
      resolve(saved_horse);
    }, error => {
      reject(error);
    });

    modal_add.componentInstance.existing_horse_selected$.subscribe((existing_horse: Horse) => {
      modal_add.close();
      resolve(existing_horse);
    });
  }

}
